<template>
  <SfSidebar
    :visible="visible"
    overlay
    :persistent="false"
    :title="title"
    class="sf-sidebar--right"
    position="right"
    @close="$emit('close')"
  >
    <template
      v-if="$slots.bar"
      #bar
    >
      <slot name="bar" />
    </template>
    <slot />
    <template #content-bottom>
      <slot name="content-bottom" />
    </template>
  </SfSidebar>
</template>

<script lang="ts">

export default defineComponent({
  name: 'SideBar',

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
});

</script>

<style lang="scss" scoped>
@use "~/assets/scss/helpers/_breakpoints" as breakpoints;
.sf-sidebar {
  --sidebar-z-index: 50;
  --overlay-z-index: 50;
  --sidebar-content-padding: var(--spacer-lg) var(--spacer-base);

  @include breakpoints.for-desktop {
    --sidebar-content-width: 700px;
    --sidebar-width: 700px;
  }
}

:deep(.sf-sidebar__content) {
  overflow: initial;
  overflow-x: hidden;
}
</style>
